import { IAddress } from './address';
import { IAsset } from './asset';
import { CurrencyCode } from './base';
import { PurchaseType } from './dc';
import { IFacility } from './facility';

export enum VendorIdentityType {
  GSTIN,
  VAT_NUMBER,
  TIN,
}

export enum VendorActivationStatus {
  ACTIVE,
  INACTIVE,
}

export enum JITOrderFulfillmentModel {
  B2B = 'B2B',
  B2B2C = 'B2B2C',
}

export const JIT_ORDER_FULFILLMENT_OPTIONS = [
  { label: JITOrderFulfillmentModel.B2B, value: JITOrderFulfillmentModel.B2B },
  {
    label: JITOrderFulfillmentModel.B2B2C,
    value: JITOrderFulfillmentModel.B2B2C,
  },
];

export const VENDOR_ORIGIN_OPTIONS = [
  { label: 'DOMESTIC', value: true },
  { label: 'INTERNATIONAL', value: false },
];

export const VENDOR_DISCOUNTING_MODE_OPTIONS = [
  { label: 'MRP Based', value: 'MRP_BASED' },
  { label: 'Cost Price Based', value: 'COST_PRICE_BASED' },
];

export const PURCHASE_TYPE_OPTIONS = [
  { label: 'DC', value: PurchaseType.DC },
  { label: 'PO', value: PurchaseType.PO },
];

export enum VendorDiscountingModel {
  MRP_BASED = 'MRP_BASED',
  COST_PRICE_BASED = 'COST_PRICE_BASED',
}

export interface IBrand {
  name: string;
  website: string;
  websiteType: string;
  isFeatured: boolean;
  logoAssetUrl: string;
  tags: [string];
}

export interface IVendor {
  id: number;
  shortCode: string;

  vinType: VendorIdentityType;
  vin: string;

  purchaseModel: PurchaseType;
  discountingModel: VendorDiscountingModel;
  isDomestic: boolean;
  currency: CurrencyCode;

  name: string;
  emails: string;
  phones: string;
  vendorBrandOptionLabel: string;

  status: VendorActivationStatus;
  brands: IBrand[];
  brandManagerId: number;
  platformMargin?: number;
  billingAddress: IAddress;
  gstAddress: IAddress;

  jitEnabled: Boolean;
  mtoEnabled: Boolean;
  mtoDiscountEnabled: Boolean;
  mtcEnabled: Boolean;
  jitOrderFulfillmentModel: JITOrderFulfillmentModel;
  jitTat: number;
  mtoTat: number;
  mtcTat: number;
  bufferTat: number;
  mtoReturnable: boolean;
  unicomVendorCode: string;
  secretKey?: string;
  salesDashboardEnabled?: boolean;

  facilities?: IFacility[];

  vendorBrandName?: string;
  vendorAssets?: {
    VENDOR_AGREEMENT?: IAsset;
  };

  jitOrderFulfillmentEnabled?: boolean;
  merchPortfolio?: string;

  whatsappGroupChatId?: string;
}
